@let hasUserUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.User);
@let hasUserReadPermission = can(RoleAction.Read, RolePermissionSubject.User);

<div class="d-flex flex-row">
  <div class="flex-grow-1">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center gap-2">
        <nz-date-picker
          nzMode="year"
          [ngModel]="selectedYear"
          (ngModelChange)="onYearSelection($event)"
        ></nz-date-picker>
        @if (isLoadingVacationData) {
          <wilson-loading-spinner
            [showSmallSpinner]="true"
          ></wilson-loading-spinner>
        }
      </div>
      <div class="d-flex" style="gap: 10px">
        <div class="d-flex justify-content-end flex-grow-1">
          <wilson-search-filter
            (modelChange)="gridService.setQuickFilter($event)"
          ></wilson-search-filter>
        </div>
        <button
          nz-button
          nzType="primary"
          nz-tooltip
          [nzTooltipTitle]="
            !hasUserReadPermission
              ? ('general.forbidden_action' | translate)
              : ''
          "
          [disabled]="!hasUserReadPermission || isExporting()"
          class="text-dark p-1 w-20 mb-2 fw-normal"
          (click)="onExport()"
          data-test-id="wilson-vacation-management:export-button"
          buttons
        >
          {{ 'general.export' | translate }}
        </button>
        <button
          nz-button
          nzType="primary"
          nz-tooltip
          [nzTooltipTitle]="
            !hasUserUpdatePermission
              ? ('general.forbidden_action' | translate)
              : ''
          "
          [disabled]="!hasUserUpdatePermission || !selectedUserVacations.length"
          class="text-dark p-1 w-20 mb-2 fw-normal"
          (click)="onEdit()"
          data-test-id="wilson-vacation-management:edit-button"
          buttons
        >
          {{ 'page.vacation_management.edit' | translate }}
        </button>
      </div>
    </div>
    @if (isLoadingSignal()) {
      <div class="loader">
        <wilson-loading-spinner></wilson-loading-spinner>
      </div>
    }
    <div class="mt-3">
      @let userVacations = userVacations$ | async;
      @if (!isLoadingSignal()) {
        @if (userVacations && userVacations.length) {
          <ag-grid-angular
            class="ag-theme-wilson"
            [defaultColDef]="defaultColDef"
            [gridOptions]="gridOptions"
            [components]="components"
            [rowData]="userVacations"
            (gridReady)="gridService.onGridReady($event)"
            (paginationChanged)="onPaginationChanged()"
            [rowSelection]="'multiple'"
            [columnDefs]="columnDefs"
            (selectionChanged)="onSelectionChanged()"
            [rowMultiSelectWithClick]="true"
          >
          </ag-grid-angular>
        } @else {
          <wilson-empty-state></wilson-empty-state>
        }
      }
    </div>
  </div>
</div>
<wilson-vacation-management-drawer
  [visible]="visible"
  (closeDrawer)="closeDrawer()"
  (saveDrawer)="saveVacations($event)"
  [selectedUserVacations]="selectedUserVacations"
  [selectedYear]="selectedYearNumber"
  [showMask]="showMask"
></wilson-vacation-management-drawer>
<wilson-progress-message
  #progressMessage
  [message]="'page.qualifications.export_table.tooltip' | translate"
></wilson-progress-message>
